export var LAYOUT_SECTION_MARGIN = 8;
export var LAYOUT_COLUMN_PADDING = LAYOUT_SECTION_MARGIN * 1.5;
export var DEFAULT_TWO_COLUMN_LAYOUT_COLUMN_WIDTH = 50;